import { motion } from "framer-motion";
import Breadcrumbs from "./Breadcrumbs";
import { img } from "../data/site";

export default function PageHero({ title, subtitle, image, crumbs }) {
  return (
    <section className="relative overflow-hidden bg-navy grain">
      <div className="absolute inset-0">
        <img src={img(image, 1600)} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-35" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/40" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 pt-14 pb-16 sm:pt-20 sm:pb-24">
        <Breadcrumbs items={crumbs} light />
        <motion.h1
          initial={{ opacity: 0, y: 26 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mt-5 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-white max-w-3xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="mt-4 text-white/75 max-w-2xl text-sm sm:text-base leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
